module.exports = __webpack_public_path__ + "static/img/14000796.018f931b.png";